import React from 'react';
import Calendar from 'react-calendar';
import { format } from 'date-fns';
import 'react-calendar/dist/Calendar.css';
import './CalendarioAgendamentos.css';

const CalendarioAgendamentos = ({ data, onChange, diasComAgendamento = [] }) => {
  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const dataFormatada = format(date, 'yyyy-MM-dd');
      if (diasComAgendamento.includes(dataFormatada)) {
        return 'highlight';
      }
    }
    return null;
  };

  return (
    <Calendar
      onChange={onChange}
      value={data}
      tileClassName={tileClassName}
      locale="pt-BR"
    />
  );
};

export default React.memo(CalendarioAgendamentos);
